import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';

class LayoutComponent {
    constructor() {
        this.primaryButtonClick = new EventEmitter();
        this.secondaryButtonClick = new EventEmitter();
    }
    primaryButtonClicked() {
        this.primaryButtonClick.emit();
    }
    secondaryButtonClicked() {
        this.secondaryButtonClick.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LayoutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LayoutComponent, selector: "ng-component", inputs: { hasPrimaryButton: "hasPrimaryButton", primaryButtonLabel: "primaryButtonLabel", primaryButtonDisabled: "primaryButtonDisabled", primaryButtonClass: "primaryButtonClass", hidePrimaryButton: "hidePrimaryButton", hasSecondaryButton: "hasSecondaryButton", showBottomSheetSecondaryButton: "showBottomSheetSecondaryButton", secondaryButtonLabel: "secondaryButtonLabel", secondaryButtonDisabled: "secondaryButtonDisabled", secondaryButtonClass: "secondaryButtonClass", hideSecondaryButton: "hideSecondaryButton" }, outputs: { primaryButtonClick: "primaryButtonClick", secondaryButtonClick: "secondaryButtonClick" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LayoutComponent, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], propDecorators: { hasPrimaryButton: [{
                type: Input
            }], primaryButtonLabel: [{
                type: Input
            }], primaryButtonDisabled: [{
                type: Input
            }], primaryButtonClass: [{
                type: Input
            }], hidePrimaryButton: [{
                type: Input
            }], hasSecondaryButton: [{
                type: Input
            }], showBottomSheetSecondaryButton: [{
                type: Input
            }], secondaryButtonLabel: [{
                type: Input
            }], secondaryButtonDisabled: [{
                type: Input
            }], secondaryButtonClass: [{
                type: Input
            }], hideSecondaryButton: [{
                type: Input
            }], primaryButtonClick: [{
                type: Output
            }], secondaryButtonClick: [{
                type: Output
            }] } });

class PanelSheetLayoutComponent extends LayoutComponent {
    constructor() {
        super(...arguments);
        this.mainTitle = true;
        this.iconClass = 'color-primary';
        this.panelContainerClass = 'panel-container';
    }
    ngAfterViewInit() {
        this.panelContainer = document.getElementsByClassName(`panel-sidenav-${this.props?.panelLevel}`)[0]?.getElementsByClassName('mat-drawer-inner-container')[0];
        this.bottomSheetContainer = document.getElementsByClassName('bottom-sheet-container')[0];
    }
    panelContainerHasScrollbar() {
        const containerElement = this.isBottomSheet() ?
            this.bottomSheetContainer :
            this.panelContainer;
        const scrollHeight = containerElement?.scrollHeight;
        const clientHeight = containerElement?.clientHeight;
        const hasScrollbar = !!scrollHeight && clientHeight && scrollHeight > clientHeight;
        return hasScrollbar;
    }
    isBottomSheet() {
        return this.props?.layoutType === 'bottom-sheet';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelSheetLayoutComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PanelSheetLayoutComponent, selector: "tg-panel-sheet-layout", inputs: { props: "props", title: "title", mainTitle: "mainTitle", subtitle: "subtitle", icon: "icon", iconClass: "iconClass", topOfTitleTemplate: "topOfTitleTemplate", sideOfTitleTemplate: "sideOfTitleTemplate", panelContainerClass: "panelContainerClass" }, usesInheritance: true, ngImport: i0, template: "" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelSheetLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tg-panel-sheet-layout', template: "" }]
        }], propDecorators: { props: [{
                type: Input
            }], title: [{
                type: Input
            }], mainTitle: [{
                type: Input
            }], subtitle: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconClass: [{
                type: Input
            }], topOfTitleTemplate: [{
                type: Input
            }], sideOfTitleTemplate: [{
                type: Input
            }], panelContainerClass: [{
                type: Input
            }] } });

class PanelSheetLayoutModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelSheetLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PanelSheetLayoutModule, declarations: [PanelSheetLayoutComponent], exports: [PanelSheetLayoutComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelSheetLayoutModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelSheetLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        PanelSheetLayoutComponent
                    ],
                    exports: [
                        PanelSheetLayoutComponent
                    ],
                    imports: []
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LayoutComponent, PanelSheetLayoutComponent, PanelSheetLayoutModule };
